import { render, staticRenderFns } from "./wzsensor.vue?vue&type=template&id=cf74a6e6&scoped=true&"
import script from "./wzsensor.vue?vue&type=script&lang=js&"
export * from "./wzsensor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf74a6e6",
  null
  
)

export default component.exports